const AUTH_TOKEN_KEY = 'mindvrik_auth_token';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

const request = async (path, options = {}) => {
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = Array.isArray(payload?.detail)
      ? payload.detail.map((item) => item.msg || item.message).filter(Boolean).join(' ')
      : payload?.detail;
    throw new Error(detail || payload?.message || 'Expert application request failed.');
  }
  return payload;
};

export const expertApplicationService = {
  submitExpertApplication(application) {
    return request('/expert-applications', {
      method: 'POST',
      body: JSON.stringify(application),
    });
  },

  getExpertApplications() {
    return request('/expert-applications/me');
  },

  getExpertApplicationById(applicationId) {
    return request(`/expert-applications/${applicationId}`);
  },

  updateExpertApplicationStatus(applicationId, status) {
    return request(`/expert-applications/${applicationId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },
};
